import type { CatalogFilters, CatalogModel } from '@/types/catalog'

export function filterModels(
  models: CatalogModel[],
  categoryId: string | null,
  filters: CatalogFilters,
): CatalogModel[] {
  return models.filter((model) => {
    if (categoryId && model.categoryId !== categoryId) {
      return false
    }

    if (filters.status === 'pinned') {
      if (!model.isPinned || model.status !== 'active') return false
    } else if (filters.status !== 'all' && model.status !== filters.status) {
      return false
    }

    if (filters.freeOnly && !model.pricing.isFree) {
      return false
    }

    if (filters.maxPrice !== null && model.pricing.inputPerMillion > filters.maxPrice) {
      return false
    }

    if (filters.providers.length > 0 && !filters.providers.includes(model.providerId)) {
      return false
    }

    return true
  })
}
